import type { EditorialPlanningSettings } from '../lib/editorial-planning-settings';
export type Run = {
  id: string;
  stage: string;
  articleId: string | null;
  topic: { title: string } | null;
  requestedTitle?: string | null;
  createdAt?: string;
  sourceRevision: string | null;
  publishAt: string | null;
  approvedAt?: string | null;
  rejectionPending?: boolean;
  preparationOwner?: boolean;
  preparationActive?: boolean;
  headingReviewReason?: string | null;
  pinterestScheduledCount?: number;
  pinterestDelivery?: 'csv';
  pinterestPlannedCount?: number;
  lastErrorCode: string | null;
  assemblyRecovery?: {retryable: boolean; message: string};
};
export type Routine = {
  planning?: EditorialPlanningSettings | null;
  enabled: boolean;
  localHour: number;
  backlogLimit: number;
  timeZone: string;
};
export type Queue = { available: boolean; routines: Routine[]; runs: Run[] };
export const labels: Record<string, string> = {
  planning: 'Planning idea',
  queued: 'Queued idea',
  editing: 'Title being edited',
  topic: 'Choosing a topic',
  structure: 'Preparing the article',
  images: 'Generating images',
  rejecting: 'Deleting rejected article',
  review: 'Ready for image review',
  assembly: 'Assembling approved article',
  publication: 'Awaiting publication',
  pinterest: 'Scheduling Pinterest',
  complete: 'Article published',
  attention: 'Needs attention',
};
export async function request<T>(method = 'GET', body?: unknown): Promise<T> {
  const response = await fetch('/api/editorial', {
    method,
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const value = await response.json();
  if (!response.ok)
    throw new Error(
      typeof value.error === 'string'
        ? value.error.replace(/_/g, ' ').toLowerCase()
        : 'Unable to load the editorial queue'
    );
  return value as T;
}
